export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-04.e3a8f6c9.jpg";